<template>
  <div style="height: inherit" v-if="itemsOptionsComplete">
    <!-- ECommerce Header -->
    <section id="ecommerce-header">
      <div class="row">
        <div class="col-3 align-items-center">
          <!-- <div class="ecommerce-header-items"> -->

            <div class="result-toggler d-flex ">
              <feather-icon icon="MenuIcon" class="d-block d-lg-none my-auto" size="36" @click="changeShowLeftSideBar" />
              <div class="search-results d-none d-lg-block">
                {{ itemsOptionsComplete.length }} {{$t("results found")}}
              </div>
            </div>

        </div>

        <div class="col-9 view-options d-flex justify-content-end align-items-center">
            <BButton variant="success" class="mr-1" @click="openChargeModal">Realizar cobro</BButton>
            <BFormGroup class="my-auto" v-slot="{ ariaDescribedby }">
                <BFormRadioGroup id="btn-radios-2" v-model="selectedItems" :options="options" :aria-describedby="ariaDescribedby" button-variant="outline-primary" name="radio-btn-outline" buttons></BFormRadioGroup>
            </BFormGroup>
            <BButton variant="primary" class="ml-1" :to="{ name: 'cash-selector' }">Gestionar cajas</BButton>
        </div>



      </div>
    </section>

    <!-- Overlay -->
    <div class="body-content-overlay" />

   <!-- Searchbar -->
    <div class="ecommerce-searchbar mt-1">
      <b-row>
        <b-col>
          <b-input-group class="input-group-merge">
            <b-form-input
              v-model="searchQuery"
              :placeholder="$t('Search product')"
              class="search-product"
            />
            <!-- Falta por poñer isto:   " -->
            <b-input-group-append is-text>
              <feather-icon
                icon="SearchIcon"
                class="text-muted"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <section >
    <b-row class="mt-1">
      <b-col cols="12" lg="3" class="d-none d-lg-block">
        <tpv-left-side-bar @filters-changed="filtersChanged" :filters="filters" :filterOptions="filterOptions"></tpv-left-side-bar>
      </b-col>


      <b-col cols="12" lg="9" >
        <b-row>
        <b-col v-for="item in itemsOptionsComplete" :key="item.id" cols="12" lg="4" sm="6">
          <b-card :key="item.i.id" class="ecommerce-card " no-body>

          <div class="item-img text-center">
              <!-- <b-img fluid :alt="item.i.name" class="card-img-top" src="https://comunidad.retorn.com/wp-content/uploads/cache/2018/09/gatitos/3008811440.jpg" /> -->
              <b-img  fluid :alt="item.i.name" class="card-img-top asd p-1" :src="require('@/assets/images/logo/logo.png')" />
          </div>

          <!-- item Details -->
          <b-card-body>
            <div class="item-wrapper">
              <div>
                <h6 class="item-price">
                  {{ formatCurrency(item.i.total) }}
                </h6>
              </div>
            </div>
            <h6 class="item-name">
              <b-link
                class="text-body"
                :to="{ name: `${selectedItems}-view`, params: { id: item.i.id } }"
              >
                {{ item.i.name }}
              </b-link>

            </h6>

          <div class="item-options ">
          <!-- course Actions -->
          <b-button variant="primary" tag="a" class="btn-cart p-1 m-0" v-show="!item.showRemoveButton" @click="addToShoppingBasket({id: item.i.id, type: selectedItems, quantity: 1})">
            <feather-icon icon="ShoppingCartIcon" class="mr-50"/>
            <span>{{ $t('Add to cart') }}</span>
          </b-button>

          <b-button variant="danger" tag="a" class="btn-cart p-1 m-0" v-show="item.showRemoveButton" @click="removeFromShoppingBasket(item.i.id, selectedItems)">
            <feather-icon icon="ShoppingCartIcon" class="mr-50"/>
            <span>{{ $t('Remove') }}</span>
          </b-button>
          </div>
          </b-card-body>

          </b-card>
        </b-col>
      </b-row>
      </b-col>
    </b-row>
    </section>

      <!-- Pagination -->
    <section >
      <b-row class="d-flex justify-content-between" >
        <BCol cols="6" lg="3" offset-lg="3" class="d-flex align-items-center justify-content-start  ">
                <span class="text-muted">{{$t('Showing')}} {{firstIndex}} {{$t('to')}} {{lastIndex}} {{$t('of')}} {{totalItems}} {{$t('entries')}}</span>
            </BCol>
        <b-col cols="6" class="d-flex align-items-center justify-content-end  ">
          <b-pagination
            v-model="currentPage"
            :total-rows=totalItems
            :per-page=perPage
            first-number
            align="center"
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >

          </b-pagination>

        </b-col>
      </b-row>
    </section>

    <section>
        <BRow class="py-4">
            <BCol cols="12" lg="9" offset-lg="3">
                <BButton size="lg" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" block :to="{ name: 'checkout' }">Continuar</BButton>
            </BCol>
        </BRow>
    </section>

    <!-- Sidebar -->
    <b-sidebar class="d-lg-none d-block" id="sidebar-toggle" left  :visible="showLeftSideBar">

        <tpv-left-side-bar @filters-changed="filtersChanged" :filters="filters" :filterOptions="filterOptions"></tpv-left-side-bar>

    </b-sidebar>

    <BModal size="lg" hide-footer ref="chargeModal" cancel-variant="outline-secondary" centered title="Realizar cobro" no-close-on-backdrop>
            <BForm @submit.prevent="">
                

                <BCol class="mb-1">
                  <label for="student_select">Estudiante</label>
                    <VueSelect id="student_select" v-model="charge.student_id" :options="students" label="search_name" :reduce="st => st.id"  v-if="students" menu-prop="auto" :filterable="false" @search="searchStudent" />
                  </BCol>
                
                <BCol class="mb-1">
                  <label for="invoice_select">Factura</label>
                  <VueSelect id="invoice_select" v-model="charge.invoice" :options="invoices" label="name_fast_charge" required v-if="invoices" :clearable="false" @search="searchInvoice" />
                </BCol>

                <BCol class="mb-1" v-if="charge.invoice">
                  <p>Importe: {{ formatCurrency(charge.invoice.amount) }}</p>
                  <p>Item: {{ charge.invoice.items[0].item }}</p>
                </BCol>

                <BCol class="mb-1">
                  <label for="payment_method">Método de pago</label>
                  <VueSelect id="payment_method"  v-model="charge.payment_method_id" :options="paymentMethods" label="name" :reduce="pay => pay.id" required v-if="paymentMethods" :clearable="false" />
                </BCol>

                <BCol v-if="cashes && showCashes">
                  <label >Caja</label>
                  <VueSelect v-model="charge.cash_id" :reduce="cash => cash.id" :options="cashes" label="name" id="payment-method" class="payment-selector" :clearable="false" :required="showCashes"/>
                </BCol>
               
                <BCol class="d-flex justify-content-end mt-2">
                    <BButton variant="danger" class="mr-1" @click="chargeModal.hide()">Cancelar</BButton>
                    <BButton variant="primary" type="submit" @click="chargeInvoice" id="submitbutton">Añadir</BButton>
                </BCol>
            </BForm>
        </BModal>
        <iframe id="iframe" width="600px" scrolling="auto" height="1000px" 
          frameborder="1"
          style="border: 0rem none #ffffff;" name="national-campaign" 
          marginheight="0rem" marginwidth="0rem">
        </iframe>
  </div>
</template>

<script>
import { onUnmounted, ref, watch, provide, computed } from '@vue/composition-api';
import i18n from "@/libs/i18n";
import courseModule from '../courses/courseModule';
import productModule from '../products/productModule';
import Ripple from 'vue-ripple-directive';
import store from '@/store';
import popups from '@/hooks/popups'
import { useShopFiltersSortingAndPagination, useShopUi, useShopRemoteData } from './tpv_filters_sorting_pagination'
import {BForm,  BModal, BFormRadioGroup, BFormGroup,  BFormRadio, BRow, BCol, BInputGroup, BFormInput, BCard, BCardBody, BLink, BImg, BCardText, BButton, BPagination,BInputGroupAppend,BDropdownItem,BDropdown,BSidebar } from 'bootstrap-vue'
import { VueSelect } from 'vue-select'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import TpvLeftSideBar from './TpvLeftSideBar.vue';
import axios from '@axios'
import invoicesModule from '../invoices/invoicesModule'
import currency from '@/utils/currency'
import exportUtils from '@/hooks/exportUtils'




export default {
    components: {BForm, BModal, BCard, BFormGroup,BCardBody, BLink, BImg, BCardText, BButton, BFormRadioGroup, BFormRadio, BRow, BCol, BInputGroup, BInputGroupAppend, BFormInput, BPagination, BDropdownItem, BDropdown, BSidebar, TpvLeftSideBar, VueSelect },
    directives: {
        Ripple,
      },
      setup(){
        const { exportData } = exportUtils()
        const { errorToast, successToast } = popups()
        const { formatCurrency } = currency()
        const _ = require('lodash')
        // Módulos
        const PRODUCT_MODULE = 'products'
        const COURSES_MODULE = 'courses'
        const INVOICE_MODULE = 'invoices'

        // Rexistro módulos
        if(!store.hasModule(PRODUCT_MODULE)) store.registerModule(PRODUCT_MODULE, productModule)
        if(!store.hasModule(COURSES_MODULE)) store.registerModule(COURSES_MODULE, courseModule)
        if (!store.hasModule(INVOICE_MODULE)) store.registerModule(INVOICE_MODULE, invoicesModule)
        // Outras variables
        const sections = ref([])
        const families = ref([])
        const courses = ref([])
        const products = ref([])
        const itemsOptions = ref([])
        const showLeftSideBar=ref(false)
        const itemsOptionsComplete=ref([])


        // Modal
        const chargeModal=ref(null)

        const charge = ref({
          payment_method_id: null,
          amount: null,
          cash_id:null, 
          invoice:null, 
          student_id:null,
          invoice_id:null
        })
       

        const paymentMethods=ref(null)
        const invoices=ref(null)
        const cashes=ref(null)
        const students=ref(null)
        const showCashes=ref(false)


        // Cesta
        const pickedItemsFromLocalStorage=ref(false)
        const shoppingBasket=ref(JSON.parse(localStorage.getItem("shoppingBasket")))

        if (shoppingBasket.value==null) {
          shoppingBasket.value=[]
        }

        const itemsFromStorage=ref(null)


        // Queries
        const searchQuery=ref(null)
        const currentPage=ref(1)
        const familyFilter=ref('')
        const sectionFilter=ref('')
        const priceFilter=ref({min:0, max: 100000})
        const searchQueryInvoices=ref(null)
        const searchQueryStudents=ref(null)



        // Pagination
        const totalItems=ref(0)
        const perPage=ref(9)
        const firstIndex=ref(null)
        const lastIndex=ref(null)


        const { itemView, itemViewOptions } = useShopUi()
        const { filters, filterOptions, sortBy, sortByOptions } = useShopFiltersSortingAndPagination()
        const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()

        // Pestaña selección Cursos | Productos
        const selectedItems= ref('courses')
        const options= ref([
          { text: i18n.t("Courses"), value: 'courses' },
          { text: i18n.t("Products"), value: 'products' }
        ])

        provide("sections", sections)
        provide("families", families)
        provide("selectedItems", selectedItems)

        // Fetchs

        const fetchStudents = () => {
          axios
          .get('/students', {params:{
            q: searchQueryStudents.value,
            perPage: 25,
            page: 1,
            sortBy: 'id',
            sortDesc: true,
            dontCheckGroup:true
          }})
          .then(response => {students.value=response.data.students;})
        }
        
        
        const fetchInvoices = () => {
          axios
          .get('/invoices', { params : {
            status: 2,
            student: charge.value.student_id, 
            q: searchQueryInvoices.value,
            perPage: 25,
            type: "ticket",
            page: 1,
            sortBy: 'id',
            sortDesc: true,
            dontCheckGroup:true
          }})
          .then(response => { invoices.value=response.data.invoices })
        }
      
        
        axios.get('/payment-methods').then(response =>{
          paymentMethods.value = response.data
        })
        
        axios.get('cashes').then(response => {
          cashes.value=response.data.cashes
        })
        
        
        
        // Watchers
        watch([searchQuery, currentPage], () => {
          getItems()
        })

        watch(selectedItems,() => {
          currentPage.value=1
          getItems()
        })

        watch(() => charge.value.payment_method_id, () => {
          if (charge.value.payment_method_id==1) {
            showCashes.value=true
          } else {
            showCashes.value=false
          }
        })

        watch(() => charge.value.student_id, () => {
          searchQueryInvoices.value = ""
          charge.value.invoice = null
          fetchInvoices();
        })

        // Métodos
        const searchInvoice = _.debounce(function (val) {
          if(val) {
            searchQueryInvoices.value = val
            fetchInvoices();
          }
        }, 500)

        const searchStudent = _.debounce(function (val) {
          if(val) {
            searchQueryStudents.value = val
            fetchStudents();
          }
        }, 500)

        const paginationData=() => {

          firstIndex.value = itemsOptionsComplete.value.length  ? (currentPage.value - 1) * perPage.value + 1 : 0
         lastIndex.value =  itemsOptionsComplete.value.length  + (currentPage.value - 1) * perPage.value
        }

        const getItems=()=> {
          if(selectedItems.value=="courses") {
            store.dispatch('courses/fetchCourses', {
                q: searchQuery.value,
                page: currentPage.value,
                section: sectionFilter.value,
                tpv: true,
                minPrice: priceFilter.value.min,
                maxPrice: priceFilter.value.max,
                perPage: perPage.value
            }).then(response => {
            courses.value = response.data.courses
            itemsOptions.value=courses.value
            totalItems.value=response.data.total
            sections.value=response.data.sections

            itemsOptionsComplete.value=itemsOptions.value.map((item)=> {return {i: item, showRemoveButton:false}})

            // Comproba se están ou non engadidos na cesta
            for (const s of shoppingBasket.value) {
              let index=itemsOptionsComplete.value.findIndex(item=> (item.i.id==s.id && selectedItems.value==s.type))
              if (index>-1) {
                itemsOptionsComplete.value[index].showRemoveButton=true
              }
            }

            paginationData()
          }).catch((error) => errorToast("Error:", error))
        } else if (selectedItems.value=="products")  {

          store.dispatch('products/fetchProducts', {
                q: searchQuery.value,
                page: currentPage.value,
                family: familyFilter.value,
                tpv: true,
                minPrice: priceFilter.value.min,
                maxPrice: priceFilter.value.max,
                perPage: perPage.value
            }).then(response => {
            products.value = response.data.products
            itemsOptions.value=products.value
            totalItems.value=response.data.total
            families.value=response.data.families

            itemsOptionsComplete.value=itemsOptions.value.map((item)=> {return {i: item, showRemoveButton:false}})

           // Comproba se están ou non engadidos na cesta
            for (const s of shoppingBasket.value) {
              let index=itemsOptionsComplete.value.findIndex(item=> (item.i.id==s.id && selectedItems.value==s.type))
              if (index>-1) {
                itemsOptionsComplete.value[index].showRemoveButton=true
              }
            }

            paginationData()
          })
          }
        }


        
        const addToShoppingBasket = (newAdded) => {

          let index=itemsOptionsComplete.value.findIndex(item=> (item.i.id==newAdded.id))
          itemsOptionsComplete.value[index].showRemoveButton=true

          shoppingBasket.value.push(newAdded);
          localStorage.setItem("shoppingBasket", JSON.stringify(shoppingBasket.value));
        }

        const removeFromShoppingBasket=(idToDelete, type) => {
          // Cambio visibilidad boton eliminar
          let index2=itemsOptionsComplete.value.findIndex(item=> (item.i.id==idToDelete))
          itemsOptionsComplete.value[index2].showRemoveButton=false
          
          //Eliminación da cesta da compra
          let index1=  shoppingBasket.value.findIndex(item => ( item.id==idToDelete && item.type.selectedItems==type))
          shoppingBasket.value.splice(index1,1)
          localStorage.setItem("shoppingBasket", JSON.stringify(shoppingBasket.value));

        }

        const changeShowLeftSideBar= () => {showLeftSideBar.value=!showLeftSideBar.value}

        const filtersChanged=(price,fam,sec) => {
          priceFilter.value=price.value
          familyFilter.value=fam
          sectionFilter.value=sec
          getItems()
        }
        
        
        const openChargeModal = () => {
          chargeModal.value.show();
          charge.value.payment_method_id=null;
          charge.value.invoice=null;
          charge.value.cash_id=null;
          charge.value.student_id=null;
          fetchInvoices()
        }
        
        const chargeInvoice=() => {
          if (!charge.value.invoice) {
            errorToast("Selecciona una factura.")
            return
          }

          if (!charge.value.payment_method_id) {
            errorToast("Selecciona un método de pago.")
            return
          }
          
          if (!charge.value.cash_id && showCashes.value) {
            errorToast("Selecciona una caja.")
            return
          }
          
          document.getElementById('submitbutton').disabled=true;
          charge.value.invoice_id=charge.value.invoice.id
          charge.value.amount=charge.value.invoice.specific_status.owe
          axios.post('charges', charge.value).then(response => {
                if (response.data.success) {
                  successToast('Charge created')

                  if (charge.value.invoice.n_invoice || charge.value.invoice.n_corrective_invoice) {
                    store.dispatch('invoices/downloadInvoice',  {idRC: charge.value.invoice_id}).then(response => {
                          document.getElementById('submitbutton').disabled=false;
                          let blob = new Blob([response.data], { type: 'application/pdf' })
                          let link = document.createElement('a')
                          link.href = window.URL.createObjectURL(blob)
                          link.download = charge.value.invoice.name+'.pdf'
                          chargeModal.value.hide()
                          printInvoice(link)
                          
                      }).catch((error)=> {
            
                        document.getElementById('submitbutton').disabled=false;

                      })
                
                  } else {

                    store.dispatch('invoices/downloadReceipt',  {idRC: charge.value.invoice_id}).then(response => {
                        document.getElementById('submitbutton').disabled=false;                      
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = charge.value.invoice.name+'.pdf'
                        chargeModal.value.hide()
                        printInvoice(link)
                    })
                  }
                  // let data = { id: response.data.charge_id }
                  // exportData('charge/export', data, 'pago_'+charge.value.invoice.name, 'PDF')

                } else {
                  document.getElementById('submitbutton').disabled=false;
                  errorToast(response.data.msg)
                }
              })
        }

        const printInvoice = (link_print) => {
            let iframe = document.getElementById("iframe"); 
            let newWindow = window.open(link_print.href, 'Dynamic Popup', 'height=' + iframe.getAttribute('height') + ', width=' + iframe.getAttribute('width')  + 'scrollbars=auto, resizable=no, location=no, status=no');
            setTimeout(function() {
              newWindow.focus();
              newWindow.print();
            }, 100);
          }


        // ---
        getItems()
        fetchInvoices()
        fetchStudents()

        // Desrexistro módulos
        onUnmounted(() => {
            if(store.hasModule(PRODUCT_MODULE)) store.unregisterModule(PRODUCT_MODULE)
            if(store.hasModule(COURSES_MODULE)) store.unregisterModule(COURSES_MODULE)
            if (store.hasModule(INVOICE_MODULE)) store.unregisterModule(INVOICE_MODULE)

        })

        return {
            products,
            sections,
            families,
            courses,
            itemView,
            itemViewOptions,
            sortByOptions,
            sortBy,
            itemViewOptions,
            filters,
            mqShallShowLeftSidebar,
            filterOptions,
            showLeftSideBar,
            changeShowLeftSideBar,
            selectedItems,
            options,
            filtersChanged,
            searchQuery,
            currentPage,
            totalItems,
            paginationData,
            firstIndex,
            lastIndex,
            perPage,
            addToShoppingBasket,
            itemsOptionsComplete,
            removeFromShoppingBasket,
            paymentMethods,
            invoices,
            cashes,
            students,
            showCashes,
            chargeModal,
            openChargeModal,
            chargeInvoice, 
            charge,
            searchQueryInvoices, 
            searchInvoice, 
            searchStudent,
            formatCurrency
        }
    }
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}

.card-img-top {
  width: 9.375rem !important;
}
</style>


